/**
 * Demo estimate for the 5D dashboard, used only when the database has no saved
 * estimate to show. It is the V201 table from the brief, stored the way the
 * Estimation tab saves it (DataGridView8 rows on the stable internal codes), so
 * it goes through exactly the same code as real data: the displayed V201.1 ...
 * V201.76 codes, the COE / COP / CPF / CPS categories and the "Ext. Painting /
 * Sq.m" wording all come from wbsConfig, not from here.
 *
 * Nothing in this file is ever written anywhere.
 */

import { buildDashboardLines } from "./buildDashboardLines";

export const DEMO_TAG = "V201";

// [internal code, description, unit, est unit (qty), est unit rate]
const ROWS = [
  ["1.1", "Engineering", "Manhour", 25, 100],
  ["1.2", "QA/QC", "Manhour", 10, 100],
  ["1.3", "Project Management", "Manhour", 12, 100],
  ["1.4", "Operations", "Manhour", 8, 100],
  ["2.1", "Shell & Head Material", "Kg", 2000, 5],
  ["2.2", "Nozzles Material", "Kg", 500, 7],
  ["2.3", "Attachments Material", "Kg", 750, 5],
  ["3.1", "Shell & Head Assembly", "Manhour", 100, 75],
  ["3.2", "Nozzle Assembly", "Manhour", 100, 75],
  ["3.3", "Attachments Assembly", "Manhour", 50, 60],
  ["3.4", "Hydrotest", "Manhour", 25, 60],
  ["4.1", "NDT", "$", 1000, 1],
  ["4.2", "Painting", "m²", 25, 50],
];

export const DEMO_REVISION = {
  documentUID: `${DEMO_TAG} · demo`,
  design: { dataEquip: { Tag: DEMO_TAG } },
  shell: { shellDesign: [{ UID: `${DEMO_TAG}-CS` }, { UID: `${DEMO_TAG}-SE` }] },
  nozzle: {
    DataGridView1: [{ UID: `${DEMO_TAG}-N1` }, { UID: `${DEMO_TAG}-N2` }],
  },
  estimation: {
    DataGridView8: ROWS.map(([code, description, unit, qty, rate]) => ({
      "WBS Code": code,
      Description: description,
      Unit: unit,
      "Est Weight": qty,
      "Est Unit Rate": rate,
      "Est Cost": qty * rate,
    })),
  },
};

export const DEMO_LINES = buildDashboardLines(DEMO_REVISION);
